import { NgModule } from 'ng-metadata/core';
import { SearchCountriesComponent } from './search-countries.component';

@NgModule({
  declarations: [
    SearchCountriesComponent,
  ],
})
export class SearchCountriesModule {}


// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/countries/search-countries.module.ts